var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHardCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2134 8.16339C11.2134 8.86248 10.6453 9.43135 9.94715 9.43135H3.68445C3.308 9.43135 3 9.12293 3 8.74596L3 6.02906C3 4.63088 4.12934 3.5 5.52562 3.5H10.5768C10.9328 3.5 11.2134 3.78101 11.2134 4.13055L11.2134 8.16339Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10677 16.5C6.33336 16.5 5.70639 15.8669 5.70639 15.086C5.70639 14.3051 6.33336 13.672 7.10677 13.672C7.88019 13.672 8.50716 14.3051 8.50716 15.086C8.50716 15.8669 7.88019 16.5 7.10677 16.5Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8818 16.5C12.1084 16.5 11.4814 15.8669 11.4814 15.086C11.4814 14.3051 12.1084 13.672 12.8818 13.672C13.6552 13.672 14.2822 14.3051 14.2822 15.086C14.2822 15.8669 13.6552 16.5 12.8818 16.5Z",
    fill: "#FBA12B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.9656V9.43154C17 7.66452 15.1347 5 13.6227 5H13.0347C12.6497 5 12.3347 5.31806 12.3347 5.70681V9.07814C12.3347 10.0535 11.316 10.6101 10.35 10.6101H3.70008C3.31508 10.6101 3.00008 11.1632 3.00008 11.552V12.9656C3.00008 14.0791 3.70697 14.989 4.77234 15.0787C4.77623 13.7803 5.81985 12.7289 7.10666 12.7289C8.39588 12.7289 9.44099 13.7842 9.44099 15.086H10.5473C10.5473 13.7842 11.5925 12.7289 12.8817 12.7289C14.169 12.7289 15.2129 13.7811 15.216 15.0801C16.2908 14.9991 17 14.0854 17 12.9656Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardCopy);
export default __webpack_public_path__ + "static/media/HardCopy.09396528b42cbf7820cb8cc36d901172.svg";
export { ForwardRef as ReactComponent };